<template>
  <custom-dialog :title="row ? `Rename Folder` : `Create Folder`">
    <template>
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template #footer-btn>
      <el-button class="btn btn-form btn-blue btn-footer" @click="submit()"
        >Submit</el-button
      >
    </template>
  </custom-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      form: {},
      rules: {
        name: [
          {
            required: true,
            message: `Please input name`,
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {
    CustomDialog,
  },
  computed: {
    ...mapState({
      visible: (state) => state.isDialogVisible,
    }),
  },
  created() {
    this.initData();
  },
  watch: {
    visible(newVisible) {
      if (newVisible) this.initData();
    },
  },
  methods: {
    initData() {
      this.form = { name: "" };
      if (this.row) this.setData();
    },
    setData() {
      this.form = { name: this.row.name };
    },

    async submit() {
      try {
        const valid = await this.$refs.ruleForm.validate();
        if (valid) {
          const setObj = {
            name: this.form.name,
          };

          if (this.row) {
            await store.dispatch("creativeFolder/updateCreativeFolderById", {
              id: this.row._id,
              setObj: setObj,
            });
          } else {
            await store.dispatch("creativeFolder/createCreativeFolder", setObj);
          }
          this.$message({ message: "Success!", type: "success" });
          store.commit("setDialogVisible", false);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
